import React from 'react'
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types'
import { Confirm } from '@workboard/wobo-ui'

import style from './styles.module.scss'

const GoalDeleteConfirmPopup = ({ onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Confirm
      isOpen
      title={`${t('Delete')} ${t('OKR')}`}
      submitLabel={t('Delete')}
      dismissLabel={t('Cancel')}
      isDanger={true}
      onDismiss={onClose}
      onSubmit={onConfirm}
      data-testid='delete_okr'
    >
      <div className={style.container}>
      {t('Are you sure you want to delete this OKR?')} {t('The objective and all associated')} 
        &nbsp;{t('key results will be deleted (except linked key results)')}.
        <p className={style.additionalText}>
        {t('To delete an individual key result')}, {t('click')} &quot;{t('Cancel')}&quot; {t('and edit')}&nbsp;{t('your Objective instead.')}
        </p>
      </div>
    </Confirm>
  );
};

GoalDeleteConfirmPopup.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default GoalDeleteConfirmPopup
